import { useEffect, useState } from "react";
import { LoadingManager } from "./index";

export const useIsPageLoaded = () => {
  const [isPageLoaded, setIsPageLoaded] = useState(
    LoadingManager.mainPageResourcesLoaded
  );

  useEffect(() => {
    const updateLoadedState = () => {
      setIsPageLoaded(true);
    };

    return LoadingManager.subscribeToMainPageResourcesLoaded(updateLoadedState);
  }, []);

  return { isPageLoaded };
};
